import { useEffect, useState } from "react";
import api from "@/lib/api";
import { money, paymentModeLabel } from "@/lib/format";
import { Loader2, ArrowDownCircle, ArrowUpCircle, Coins } from "lucide-react";

const PERIODS = [{ k: "today", l: "Aujourd'hui" }, { k: "week", l: "Semaine" }, { k: "month", l: "Mois" }, { k: "year", l: "Année" }, { k: "all", l: "Tout" }];

export default function Tresorerie() {
  const [period, setPeriod] = useState("month");
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    setLoading(true);
    api.get(`/finance/treasury?period=${period}`).then((r) => setData(r.data)).finally(() => setLoading(false));
  }, [period]);

  return (
    <div className="space-y-6">
      <div className="flex flex-col sm:flex-row sm:items-center justify-between gap-3">
        <div><h1 className="text-2xl sm:text-3xl font-bold font-heading">Trésorerie</h1><p className="text-slate-500 text-sm mt-1">Entrées, sorties et solde de trésorerie</p></div>
        <div className="flex gap-1 bg-white border rounded-xl p-1">
          {PERIODS.map((p) => <button key={p.k} data-testid={`treso-period-${p.k}`} onClick={() => setPeriod(p.k)} className={`px-3 py-1.5 rounded-lg text-sm font-medium ${period === p.k ? "bg-brand-600 text-white" : "text-slate-600 hover:bg-slate-50"}`}>{p.l}</button>)}
        </div>
      </div>

      {loading || !data ? <div className="h-40 flex items-center justify-center"><Loader2 className="w-6 h-6 animate-spin text-brand-600" /></div> : (
        <>
          <div className="grid grid-cols-1 sm:grid-cols-3 gap-4">
            <div className="bg-white border rounded-2xl p-5"><div className="w-10 h-10 rounded-xl bg-emerald-50 text-emerald-600 flex items-center justify-center"><ArrowDownCircle className="w-5 h-5" /></div><div data-testid="treso-in" className="mt-3 text-2xl font-bold font-heading">{money(data.total_in)}</div><div className="text-sm text-slate-500">Entrées (encaissements)</div></div>
            <div className="bg-white border rounded-2xl p-5"><div className="w-10 h-10 rounded-xl bg-red-50 text-red-600 flex items-center justify-center"><ArrowUpCircle className="w-5 h-5" /></div><div data-testid="treso-out" className="mt-3 text-2xl font-bold font-heading">{money(data.total_out)}</div><div className="text-sm text-slate-500">Sorties (dépenses)</div></div>
            <div className="bg-brand-600 text-white rounded-2xl p-5"><div className="w-10 h-10 rounded-xl bg-white/20 flex items-center justify-center"><Coins className="w-5 h-5" /></div><div data-testid="treso-net" className="mt-3 text-2xl font-bold font-heading">{money(data.net)}</div><div className="text-sm text-white/80">Trésorerie nette</div></div>
          </div>

          <div className="grid lg:grid-cols-2 gap-6">
            <div className="bg-white border rounded-2xl p-5">
              <h3 className="font-semibold mb-3">Entrées par mode</h3>
              {Object.entries(data.inflows).map(([m, v]) => (
                <div key={m} className="flex justify-between py-2 border-b last:border-0 text-sm"><span className="text-slate-600">{paymentModeLabel[m] || m}</span><b>{money(v)}</b></div>
              ))}
            </div>
            <div className="bg-white border rounded-2xl p-5">
              <h3 className="font-semibold mb-3">Sorties par catégorie</h3>
              {Object.keys(data.outflows).length === 0 && <p className="text-sm text-slate-400">Aucune dépense</p>}
              {Object.entries(data.outflows).map(([c, v]) => (
                <div key={c} className="flex justify-between py-2 border-b last:border-0 text-sm"><span className="text-slate-600">{c}</span><b className="text-red-600">-{money(v)}</b></div>
              ))}
            </div>
          </div>
        </>
      )}
    </div>
  );
}
